export default __webpack_public_path__ + "static/media/gift.84336647.svg";